import { Link } from "react-router-dom";
import { LinkButton } from "@/components/LinkButton";
import { Wordmark } from "@/components/brand/Wordmark";

export function NotFoundPage() {
  return (
    <main className="mx-auto flex min-h-dvh max-w-xl flex-col justify-center px-5 break-keep">
      <Link to="/" aria-label="텔뷰 처음으로">
        <Wordmark />
      </Link>
      <h1 className="mt-8 wds-title-2 text-label-strong">찾는 페이지가 없어요</h1>
      <p className="mt-3 text-body-1 text-label-neutral">
        주소가 바뀌었거나 사라졌어요. 처음 화면에서 다시 찾아봐 주세요.
      </p>
      <LinkButton to="/" size="large" className="mt-8 w-fit">
        처음으로 가기
      </LinkButton>
    </main>
  );
}
